webpackJsonp([17],{

/***/ 864:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_nigeria_map_data__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_nigeria_map_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_js_on_nigeria_map_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_on_vue_multiselect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(414);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import LineChart from './chartTypes/charts'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CompareSection",
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_4__assets_js_on_vue_multiselect__["a" /* default */]
    // LineChart
  },
  props: ["relatedIndicator"],
  data: function data() {
    var _stateToShortCode;

    var data = [["ng-ne", 0], ["ng-nw", 1], ["ng-nc", 2], ["ng-se", 3], ["ng-sw", 4], ["ng-ss", 5]];
    var state_data = [["ng-ri", 0], ["ng-kt", 1], ["ng-so", 2], ["ng-za", 3], ["ng-yo", 4], ["ng-ke", 5], ["ng-ad", 6], ["ng-bo", 7], ["ng-ak", 8], ["ng-ab", 9], ["ng-im", 10], ["ng-by", 11], ["ng-be", 12], ["ng-cr", 13], ["ng-ta", 14], ["ng-kw", 15], ["ng-la", 16], ["ng-ni", 17], ["ng-fc", 18], ["ng-og", 19], ["ng-on", 20], ["ng-ek", 21], ["ng-os", 22], ["ng-oy", 23], ["ng-an", 24], ["ng-ba", 25], ["ng-go", 26], ["ng-de", 27], ["ng-ed", 28], ["ng-en", 29], ["ng-eb", 30], ["ng-kd", 31], ["ng-ko", 32], ["ng-pl", 33], ["ng-na", 34], ["ng-ji", 35], ["ng-kn", 36]];
    return {
      states: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      stateToShortCode: (_stateToShortCode = {
        Abia: "ng-ab",
        Adamawa: "ng-ad",
        "Akwa Ibom": "ng-ak",
        Anambra: "ng-an",
        Bauchi: "ng-ba",
        Benue: "ng-be",
        Borno: "ng-bo"
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Bauchi", "ng-ba"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Bayelsa", "ng-by"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Cross River", "ng-cr"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Delta", "ng-de"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Ebonyi", "ng-eb"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Edo", "ng-ed"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Ekiti", "ng-ek"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Enugu", "ng-en"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "FCT", "ng-fc"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Gombe", "ng-go"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Imo", "ng-im"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Jigawa", "ng-ji"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Kano", "ng-kn"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Katsina", "ng-kt"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Kaduna", "ng-kd"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Kebbi", "ng-ke"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Kogi", "ng-ko"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Kwara", "ng-kw"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Lagos", "ng-la"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Nasarawa", "ng-na"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Niger", "ng-ni"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Ogun", "ng-og"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Ondo", "ng-on"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Osun", "ng-os"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Oyo", "ng-oy"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Plateau", "ng-pl"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Rivers", "ng-ri"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Sokoto", "ng-so"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Taraba", "ng-ta"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Yobe", "ng-yo"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, "Zamfara", "ng-za"), _stateToShortCode),
      senateZones: ["South-East", "North-Central", "North-East", "North-West", "South-South", "South-West"],
      lsData: JSON.parse(localStorage.getItem("car_other_dataset")),
      meta_data_dataset: JSON.parse(localStorage.getItem("meta_data_dataset")),
      indicatorIndex: null,
      percentage: null,
      noStateData: false,
      noZoneData: false,
      zonesData: {},
      statesData: {},
      chartData: [],
      yearOptions: [],
      sources: [],
      compareSecSources: [],
      state: "National",
      year: null,
      source: null,
      selectedIndicator: "ANC Coverage (4 visits)",
      yearPlaceholder: null,
      sourcePlaceholder: null,
      indicatorPlaceholder: "ANC Coverage (4 visits)",
      indicatorMultiselectOpened: false,
      optionYearMultiselectOpened: false,
      sourcesMultiselectOpened: false,
      relatedIndicatorOne: null,
      relatedIndicatorTwo: null,
      specificComponentType: "Map",
      componentType: "Map",
      specificMapType: "states",
      specificChartType: "line",
      expandedView: false,
      expandedBoolVal: false,

      colors: ["#2f7ed8", "#0d233a", "#8bbc21", "#910000", "#1aadce", "#492970", "#f28f43", "#77a1e5", "#c42525", "#a6c96a"],
      zoneToShortCode: {
        "North-East": "ng-ne",
        "North-West": "ng-nw",
        "North-Central": "ng-nc",
        "South-East": "ng-se",
        "South-West": "ng-sw",
        "South-South": "ng-ss"
      },
      highchart_options: {
        chart: {
          type: "line",
          height: 440,
          zoomType: "xy"
        },
        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: "category",
          categories: null,
          title: {
            enabled: false,
            text: "x-axis title"
          },
          labels: {
            style: {
              fontWeight: "normal",
              color: "#686464"
            }
          },
          tickInterval: 4,
          showLastLabel: true
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          min: 0,
          title: {
            text: ""
          }
        },
        legend: {
          enabled: true,
          verticalAlign: "top",
          x: -20,
          y: -5,
          title: {},
          itemStyle: {
            fontWeight: "normal",
            fontSize: "13px"
          }
        },
        plotOptions: {
          series: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
            connectNulls: true,
            borderWidth: 0,
            dataLabels: {
              enabled: false,
              format: "{point.y:.1f}%",
              style: {
                fontWeight: "normal"
              }
            },
            cursor: "pointer",
            dashStyle: "Solid",
            point: {},
            marker: {
              lineWidth: 0,
              radius: 3,
              symbol: "circle"
            }
          }, "connectNulls", true),
          colorByPoint: true
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px"><b>{series.name}</b></span><br>',
          pointFormat: "<span><b>{point.x}: {point.y:.2f}</b></span><br/>"
        },
        series: [{
          name: "example",
          data: []
        }],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "openInCloud"],
              symbol: "download"
            }
          }
        }
      },
      zoneOptions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        chart: {
          map: "countries/ng/ng-all",
          borderColor: "#335cad",
          height: 438
        },

        colors: ["#2f7ed8", "#0d233a", "#8bbc21", "#910000", "#1aadce", "#492970", "#f28f43", "#77a1e5", "#c42525", "#a6c96a"],

        credits: {
          enabled: true,
          text: "Map of Nigeria"
        },

        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },

        exporting: {
          csv: {
            dateFormat: "%Y-%m-%d"
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right"
          }
        },

        legend: {
          enabled: true,
          layout: "horizontal",
          align: "right"
        },

        colorAxis: {
          // min: 0,
          // max: 100,
          minColor: "#E6E7E8",
          maxColor: "#114663"
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data___default.a, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              allowOverlap: true,
              align: "center",
              crop: true,
              style: {
                fontFamily: "'Open Sans', sans-serif",
                fontSize: 10
              },
              enabled: true,
              //format: '{point.name}',
              color: "#FFFFFF",
              formatter: function formatter() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value:.2f}</b>"
            }
          }
        },
        series: [{
          type: "map",
          data: data,
          name: "Random Name"
        }]
      }, "exporting", {
        buttons: {
          contextButton: {
            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
            //"viewData",
            "openInCloud"],
            symbol: "download"
            // symbolStrokeWidth: 2,
            // symbolFill: '#330033',
            // symbolStroke: '#b3d4fc'
          }
        }
      }),
      stateOptions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              height: 550
            }
          }]
        },
        chart: {
          map: "countries/ng/ng-all",
          borderColor: "#335cad",
          style: {
            fontFamily: "'Open Sans', sans-serif",
            fontSize: "12px"
          },
          height: 438
        },

        colors: ["#2f7ed8", "#0d233a", "#8bbc21", "#910000", "#1aadce", "#492970", "#f28f43", "#77a1e5", "#c42525", "#a6c96a"],

        credits: {
          enabled: true,
          text: "Map of Nigeria"
        },

        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },

        exporting: {
          csv: {
            dateFormat: "%Y-%m-%d"
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right"
          }
        },
        legend: {
          enabled: true,
          layout: "vertical",
          align: "right"
        },
        colorAxis: {
          minColor: "#E6E7E8",
          maxColor: "#114663"
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: __WEBPACK_IMPORTED_MODULE_3__assets_js_on_nigeria_map_data___default.a,
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              color: "#FFFFFF",
              formatter: function formatter() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value:.2f}</b>"
            }
          }
        },
        series: [{
          data: state_data,
          name: "Random Name"
        }]
      }, "exporting", {
        buttons: {
          contextButton: {
            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
            //"viewData",
            "openInCloud"],

            symbol: "download"
          }
        }
      })
    };
  },

  computed: {
    programAreas: function programAreas() {
      var meta_data = this.meta_data_dataset.slice(0);
      var programAreas = [];
      meta_data.forEach(function (datas, index) {
        if (index > 0) {
          //We are getting the program area located at index 6 of the array
          programAreas.push(datas[6]);
        }
      });
      var distinct = function distinct(value, index, array) {
        return array.indexOf(value) === index;
      };
      var distinctProgramAreas = programAreas.filter(distinct);
      return distinctProgramAreas;
    },
    indicatorAndProgramAreas: function indicatorAndProgramAreas() {
      var _this = this;

      var indicatorAndProgramArea = [];
      this.programAreas.map(function (area) {
        var tempIndicators = [];
        _this.meta_data_dataset.slice(0).filter(function (datas, index) {
          if (datas[6] === area) {
            tempIndicators.push(datas[0]);
          }
        });

        var obj = {
          programArea: area,
          indicators: tempIndicators
        };
        indicatorAndProgramArea.push(obj);
      });
      return indicatorAndProgramArea;
    },
    relatedIndicators: function relatedIndicators() {
      var allRelatedIndicators = null;
      var relatedIndicators = [];
      var self = this;

      this.indicatorAndProgramAreas.forEach(function (datas) {
        datas.indicators.filter(function (data) {
          if (data === self.selectedIndicator) {
            allRelatedIndicators = datas.indicators;
          }
        });
      });
      allRelatedIndicators = allRelatedIndicators.filter(function (indicator) {
        return indicator !== self.selectedIndicator;
      });
      return allRelatedIndicators;
    },
    indicatorAndSourceIndex: function indicatorAndSourceIndex() {
      var indicatorAndSource = this.selectedIndicator + " -> " + this.source;
      var indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);
      return indicatorIndex;
    },
    selectedState: function selectedState() {
      return this.$store.state.CAR.selectedState;
    }
  },
  methods: {
    loadData: function loadData() {
      var self = this;
      this.yearOptions = [];
      this.compareSecSources = [];
      var statesWithData = [];
      // this.states = []

      // Trying to locate the column that the data exists in the localstorage and getting the sources for the indicator
      this.lsData.forEach(function (datas, index) {
        if (index === 0) {
          datas.filter(function (data) {
            // checking for the selected indicator matches
            var isMatched = data.includes(self.selectedIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });

      /**
       * If the sources available don't have NDHS, use the 1st index or else use the index of NDHS
       */
      if (this.compareSecSources.indexOf("MICS") < 0) {
        this.source = this.compareSecSources[0];
        this.sourcePlaceholder = this.compareSecSources[0];
      } else {
        this.source = this.compareSecSources[this.compareSecSources.indexOf("MICS")];
        this.sourcePlaceholder = this.compareSecSources[this.compareSecSources.indexOf("MICS")];
      }

      var indicatorAndSource = this.selectedIndicator + " -> " + this.source;

      // This is where we get the indicatorAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach(function (datas, indexOne) {
        datas.forEach(function (data, indexTwo) {
          if (indexTwo === self.indicatorIndex && datas[self.indicatorIndex] !== "" && indexOne !== 0) {
            self.yearOptions.push(datas[0].toString());
            // With the below option we are getting the states that have data for that indicator and source
            statesWithData.push(datas[1]);
            // self.states.push(datas[1])
          }
        });
      });

      // Get distinct years
      var distinct = function distinct(value, index, array) {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct).sort();
      statesWithData = statesWithData.filter(distinct);
      // this.states = this.states.filter(distinct)

      this.yearOptions.sort(function (a, b) {
        return b - a;
      });

      // Here we the yearPlaceholder is being set to the value of the last index
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(this.selectedIndicator, this.source, this.year);
      this.getStateYearsData(this.selectedState);
    },
    resetIndicatorData: function resetIndicatorData() {
      var newIndicator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedIndicator;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
      var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.selectedState;

      var self = this;
      this.yearOptions = [];
      this.compareSecSources = [];

      // Trying to locate the column that the data exists in the localstorage
      this.lsData.forEach(function (datas, index) {
        if (index === 0) {
          datas.filter(function (data) {
            // checking for the selected indicator matches
            var isMatched = data.includes(newIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });

      if (this.compareSecSources.indexOf(source) > -1) {
        this.source = source;
        this.sourcePlaceholder = source;
      } else {
        this.source = this.compareSecSources[0];
        this.sourcePlaceholder = this.compareSecSources[0];
      }

      // this.source = this.compareSecSources[0]
      // this.sourcePlaceholder = this.compareSecSources[0]
      var indicatorAndSource = newIndicator + " -> " + this.source;

      // This is where we get the indicatorsAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach(function (datas, indexOne) {
        datas.forEach(function (data, indexTwo) {
          if (indexTwo === self.indicatorIndex && datas[self.indicatorIndex] !== "" && indexOne !== 0) {
            self.yearOptions.push(datas[0].toString());
            // With the below option we are getting the states that have data for that indicator and source
          }
        });
      });

      // This functions return distinct years
      var distinct = function distinct(value, index, array) {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct);

      this.yearOptions.sort(function (a, b) {
        return b - a;
      });

      // Here we the yearPlaceholder and year properties are being set to the value of the lastitem in the array
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(newIndicator, this.source, this.year);
      this.getStateYearsData(this.selectedState);
    },
    resetSourceData: function resetSourceData() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.source;

      var indicatorAndSource = this.selectedIndicator + " -> " + source;
      var self = this;
      this.yearOptions = [];

      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach(function (datas, indexOne) {
        datas.forEach(function (data, indexTwo) {
          if (indexTwo === self.indicatorIndex && datas[self.indicatorIndex] !== "" && indexOne !== 0) {
            self.yearOptions.push(datas[0].toString());
          }
        });
      });

      // This functions return distinct years
      var distinct = function distinct(value, index, array) {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct);

      this.yearOptions.sort(function (a, b) {
        return b - a;
      });

      // Here we the yearPlaceholder and year properties are being set to the value of the lastitem in the array
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(this.selectedIndicator, source, this.year);
      this.getStateYearsData(this.selectedState);
    },
    updateCompareSecSources: function updateCompareSecSources() {
      var newIndicator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedIndicator;

      this.compareSecSources = [];

      var self = this;
      this.lsData.forEach(function (datas, index) {
        if (index === 0) {
          datas.filter(function (data) {
            // checking for the selected indicator matches
            var isMatched = data.includes(newIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });
    },
    getAllStatesAndZonesData: function getAllStatesAndZonesData() {
      var indicator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedIndicator;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
      var year = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.year;

      // reset datas
      this.allData = [];
      var self = this;

      var indicatorAndSource = indicator + " -> " + source;

      // This is where we get the indicatorAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      this.lsData.map(function (datas) {
        // Here we are getting data by year and the index of the selected Source & Indicator,
        // only picking non empty values and would not include National data
        if (datas[0] === parseInt(year) && datas[self.indicatorIndex] !== "" && datas[1] !== "National") {
          self.allData.push({
            state: datas[1],
            value: parseFloat(datas[self.indicatorIndex].toFixed(2))
          });
        }
      });

      this.plotZoneMap(indicator, source, year, this.allData);
      this.plotStateMap(indicator, source, year, this.allData);
      //switches to line chart if there is no data in zonal and state
      // console.log(self.allData);
      this.automaticSwitchFunction(self.allData);
    },


    /*The function automatically switches to line chart when there is no data
    for both of the maps(state and zonal).
    and switch to zonal maps when there is available data on zonal
    and no data for state maps
    */
    automaticSwitchFunction: function automaticSwitchFunction(data) {
      // the if statement checks the current position on the component
      if (this.specificMapType == 'zones' || this.specificMapType == 'states') {
        if (data.length < 6) {
          this.$refs.stateBotton.click();
        }
        if (data.length == 6) {
          // if data length is 6. it means only zonal data is available
          // so switch to zonal maps
          this.$refs.zonalBotton.click();
        }
        if (data.length == 0) {
          //if there is no data in array switch to line chart
          this.$refs.lineBotton.click();
          this.$refs.lineBotton.classList.add('compare-option-selected');
          this.$refs.stateBotton.classList.remove('compare-option-selected');
        }
      }
    },
    getStateYearsData: function getStateYearsData() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedState;

      this.chartData = [];

      // get stateYears data
      var self = this;
      this.lsData.map(function (datas) {
        if (datas[1] === state && datas[self.indicatorAndSourceIndex] !== "" && datas[self.indicatorAndSourceIndex] !== undefined) {
          _this2.chartData.push([datas[0], parseFloat(datas[self.indicatorAndSourceIndex].toFixed(2))]);
        }
      });
      this.plotChart(this.chartData);
    },
    plotChart: function plotChart(data) {
      this.highchart_options.title.type = this.specificChartType;
      this.highchart_options.title.text = this.selectedIndicator;
      this.highchart_options.subtitle.text = this.source + " - " + this.selectedState;
      this.highchart_options.series[0].name = this.source;
      this.highchart_options.series[0].data = data;

      var color = this.colors[Math.floor(Math.random() * 10)];
      this.highchart_options.series[0].color = color;
      this.highchart_options.exporting.filename = this.specificChartType + " (" + this.source + ")";
      this.highchart_options.plotOptions.series.maxPointWidth = 8;

      if (data.length < 8) {
        this.highchart_options.xAxis.tickInterval = 1;
      } else if (data.length < 16) {
        this.highchart_options.xAxis.tickInterval = 2;
      } else if (data.length < 24) {
        this.highchart_options.xAxis.tickInterval = 4;
      } else {
        this.highchart_options.xAxis.tickInterval = 8;
      }
    },
    plotZoneMap: function plotZoneMap(indicator, source, year, allData) {
      /**
       * Separate zones data
       */
      this.zonesData = {};
      var zoneData = [];
      var self = this;
      this.senateZones.filter(function (zone) {
        self.zonesData[zone] = {};
        allData.forEach(function (datas) {
          if (datas.state === zone && datas.value !== "") {
            zoneData.push(datas.value);
            self.zonesData[zone] = datas.value;
          }
        });
      });

      /**
       * Checking if there is zone data returns true or false
       */
      this.noZoneData = zoneData.length ? false : true;

      /**
       * Setting options for Map
       */
      this.zoneOptions.title.text = indicator;
      this.zoneOptions.exporting.filename = indicator + " (" + source + " - " + year + ")";
      this.zoneOptions.subtitle.text = source + " - " + year;
      this.zoneOptions.series[0].name = source;
      this.zoneOptions.series[0].data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.zoneToShortCode).map(function (elem, index) {
        return [self.zoneToShortCode[elem], self.zonesData[elem]];
      });
    },
    plotStateMap: function plotStateMap(indicator, source, year, allData) {
      var _this3 = this;

      /**
       * Separate states data excluding National data
       */
      this.statesData = {};
      var stateData = [];
      var self = this;
      this.states.filter(function (state) {
        if (state !== "National") {
          _this3.statesData[state] = {};
          allData.forEach(function (datas) {
            if (datas.state === state) {
              stateData.push(datas.value);
              _this3.statesData[state] = datas.value;
            }
          });
        }
      });

      /**
       * Checking if there is state data returns true or false
       */
      this.noStateData = stateData.length ? false : true;

      /**
       * Setting options for Map
       */
      this.stateOptions.title.text = indicator;
      this.stateOptions.subtitle.text = source + " - " + year;
      this.stateOptions.exporting.filename = indicator + " (" + source + " - " + year + ")";
      this.stateOptions.series[0].name = source;
      this.stateOptions.legend = {
        enabled: true,
        layout: "horizontal",
        align: "right"
      };
      this.stateOptions.series[0].data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stateToShortCode).map(function (elem, index) {
        return [self.stateToShortCode[elem], self.statesData[elem]];
      });
    },
    getRelatedIndicators: function getRelatedIndicators() {
      var start = 0;
      var end = this.relatedIndicators.length - 1;

      // This function return a range btw 0 and the length of the relatedIndicators array
      function range(start, end) {
        var ans = [];
        for (var i = start; i <= end; i++) {
          ans.push(i);
        }
        return ans;
      }
      var val = range(start, end); // return an array of ranges form 0 to the length of the relatedIndicators array

      var relatedIndexOne = Math.floor(Math.random() * end);
      var relatedIndexTwo = Math.floor(Math.random() * end);

      // Checks if the 2nd random number is equal to the 1st
      // then it increases or decreases the 2nd random number
      if (relatedIndexOne === relatedIndexTwo) {
        if (relatedIndexTwo <= end) {
          relatedIndexTwo++;
        } else {
          relatedIndexTwo--;
        }
      }

      this.relatedIndicatorOne = this.relatedIndicators[relatedIndexOne];
      this.relatedIndicatorTwo = this.relatedIndicators[relatedIndexTwo];
    },
    compareSectionClicked: function compareSectionClicked() {
      //Event listener to change background color of clicked div
      var sections = document.querySelectorAll(".comparison-options");
      if (sections.length > 0) {
        var section1 = [],
            section2 = [],
            section3 = [];
        for (var i in sections) {
          if (i < 5) {
            section1.push(sections[i]);
          } else if (i > 4 && i < 10) {
            section2.push(sections[i]);
          } else if (i > 9 && i < sections.length) {
            section3.push(sections[i]);
          }
        }
        sections.forEach(function (section, index) {
          section.addEventListener("click", function () {
            if (index < 5) {
              section1.forEach(function (el) {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(" compare-option-selected", "");
                }
              });
            } else if (index > 4 && index < 10) {
              section2.forEach(function (el) {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(" compare-option-selected", "");
                }
              });
            } else if (index > 9 && index < sections.length) {
              section3.forEach(function (el) {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(" compare-option-selected", "");
                }
              });
            }
            section.className += " compare-option-selected";
          });
        });
      }
    },
    openedIndicatorMultiselect: function openedIndicatorMultiselect() {
      this.indicatorPlaceholder = "Search indicator";
    },
    closedIndicatorMultiselect: function closedIndicatorMultiselect() {
      this.indicatorPlaceholder = this.selectedIndicator;
    },
    openedYearOptionMultiselect: function openedYearOptionMultiselect() {
      this.optionYearMultiselectOpened = true;
      this.yearPlaceholder = "Choose a year";
    },
    closedYearOptionMultiselect: function closedYearOptionMultiselect() {
      this.optionYearMultiselectOpened = false;
      var index = this.yearOptions.indexOf(this.year);
      this.yearPlaceholder = this.yearOptions[index];
    },
    openedcompareSecSourcesMultiselect: function openedcompareSecSourcesMultiselect() {
      this.sourcesMultiselectOpened = true;
      this.sourcePlaceholder = "Choose a Source";
    },
    closedcompareSecSourcesMultiselect: function closedcompareSecSourcesMultiselect() {
      this.sourcesMultiselectOpened = false;
      this.sourcePlaceholder = this.source;
    },
    changeComponent: function changeComponent(type) {
      this.specificComponentType = type;
      if (type === "zones" || type === "states") {
        this.componentType = "Map";
        this.specificMapType = type;
      } else {
        this.componentType = "Charts";
        this.specificChartType = type;
      }
    },
    expandedBool: function expandedBool() {
      this.expandedBoolVal = true;
      this.expandedView = true;
    },
    closeExpandedBool: function closeExpandedBool(val) {
      this.expandedBoolVal = false;
      this.expandedView = false;
    }
  },
  mounted: function mounted() {
    this.selectedIndicator = this.relatedIndicator;
    this.indicatorPlaceholder = this.relatedIndicator;

    this.loadData();
    this.updateCompareSecSources();
  },
  updated: function updated() {
    this.compareSectionClicked();
  },

  watch: {
    year: function year(newYearOption, old) {
      this.getAllStatesAndZonesData(this.selectedIndicator, this.source, newYearOption);
    },
    selectedIndicator: function selectedIndicator(newIndicator, oldIndicator) {
      this.resetIndicatorData(newIndicator, this.source, this.selectedState);
      this.yearPlaceholder = !this.yearOptions.length ? "No Year Data" : this.year.toString();
      this.getStateYearsData(this.selectedState);
    },
    source: function source(newSource, oldSource) {
      this.resetSourceData(newSource);
      this.getStateYearsData(this.selectedState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.year.toString()
    },
    state: function state(newState, oldState) {
      this.getStateYearsData(newState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.yearOptions[0].toString()
    },
    selectedState: function selectedState(newState, oldState) {
      this.getStateYearsData(newState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.yearOptions[0].toString()
    },
    relatedIndicator: function relatedIndicator(newIndicator, old) {
      this.selectedIndicator = newIndicator;
      this.indicatorPlaceholder = newIndicator;
      this.relatedIndicator = newIndicator;
      this.resetIndicatorData(newIndicator, this.source, this.selectedState);
      this.getStateYearsData(this.selectedState);
    },
    chartData: function chartData(val, old) {
      this.plotChart(val);
    },
    specificChartType: function specificChartType(val, old) {
      this.highchart_options.chart.type = val;
    }
  }
});

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, ".svg-inline--fa.fa-w-12{width:.4em!important}#map-icon,.application--light .icon{margin-left:5px}#map-icon{width:1.6em!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/CompareSec.vue"],"names":[],"mappings":"AACA,wBACI,oBAAwB,CAC3B,AAKD,oCAFI,eAAiB,CAKpB,AAHD,UAEI,qBAAuB,CAC1B","file":"CompareSec.vue","sourcesContent":["\n.svg-inline--fa.fa-w-12 {\n    width: .40em !important;\n}\n.application--light .icon {\n    /* color: inherit !important; */\n    margin-left: 5px;\n}\n#map-icon {\n    margin-left: 5px;\n    width:1.6em !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(907);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("387cdaa1", content, true, {});

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-xs-12 col-md-4 compare-indicators",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('div', {
    staticClass: "panel panel-primary widget",
    attrs: {
      "id": "widget_"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row compare-panel-switch"
  }, [_c('div', {
    staticClass: "col-xs-2 comparison-options",
    on: {
      "click": function($event) {
        _vm.expandedBool()
      }
    }
  }, [_c('span', {}, [_vm._v("EXPAND")]), _vm._v(" "), _c('v-icon', [_vm._v("zoom_out_map")])], 1), _vm._v(" "), _c('div', {
    ref: "zonalBotton",
    staticClass: "col-xs-offset-2 col-xs-2 comparison-options",
    on: {
      "click": function($event) {
        _vm.changeComponent('zones')
      }
    }
  }, [_c('span', {}, [_vm._v("ZONES MAP")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "map-icon",
      "src": "static/img/icons/map-icon.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('div', {
    ref: "stateBotton",
    staticClass: "col-xs-2 comparison-options compare-option-selected",
    on: {
      "click": function($event) {
        _vm.changeComponent('states')
      }
    }
  }, [_c('span', {}, [_vm._v("STATES MAP ")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "map-icon",
      "src": "static/img/icons/map-icon.svg",
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('div', {
    ref: "lineBotton",
    staticClass: "col-xs-2 comparison-options",
    on: {
      "click": function($event) {
        _vm.changeComponent('line')
      }
    }
  }, [_c('span', {}, [_vm._v("LINE CHART")]), _vm._v(" "), _c('v-icon', [_vm._v("show_chart")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 comparison-options",
    on: {
      "click": function($event) {
        _vm.changeComponent('column')
      }
    }
  }, [_c('span', {}, [_vm._v("COLUMN CHART")]), _vm._v(" "), _c('v-icon', [_vm._v("bar_chart")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row panel-body"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.componentType === 'Map'),
      expression: "componentType==='Map'"
    }]
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorAndProgramAreas,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No indicator found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.compareSecSources,
      "allow-empty": false,
      "AllowEmpty": false,
      "show-labels": false,
      "placeholder": _vm.sourcePlaceholder
    },
    on: {
      "open": _vm.openedcompareSecSourcesMultiselect,
      "close": _vm.closedcompareSecSourcesMultiselect
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No source found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.yearOptions,
      "disable": !_vm.yearOptions.length,
      "allow-empty": false,
      "AllowEmpty": false,
      "show-labels": false,
      "placeholder": _vm.yearPlaceholder
    },
    on: {
      "open": _vm.openedYearOptionMultiselect,
      "close": _vm.closedYearOptionMultiselect
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specificMapType === 'states'),
      expression: "specificMapType==='states'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.noStateData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.stateOptions
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specificMapType === 'zones'),
      expression: "specificMapType==='zones'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.noZoneData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.zoneOptions
    }
  })], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.expandedView,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.expandedView = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-6 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorAndProgramAreas,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No indicator found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.compareSecSources,
      "allow-empty": false,
      "group-select": false,
      "hide-selected": false,
      "placeholder": _vm.sourcePlaceholder,
      "show-labels": false
    },
    on: {
      "open": _vm.openedcompareSecSourcesMultiselect,
      "close": _vm.closedcompareSecSourcesMultiselect
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No source found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.yearOptions,
      "disable": !_vm.yearOptions.length,
      "allow-empty": false,
      "placeholder": _vm.yearPlaceholder,
      "hide-selected": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedYearOptionMultiselect,
      "close": _vm.closedYearOptionMultiselect
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1)])]), _vm._v(" "), _c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specificMapType === 'states'),
      expression: "specificMapType==='states'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.noStateData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.stateOptions
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.specificMapType === 'zones'),
      expression: "specificMapType==='zones'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.noZoneData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.zoneOptions
    }
  })], 1)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeExpandedBool
    }
  }, [_vm._v("CLOSE")])])])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.componentType === 'Charts'),
      expression: "componentType === 'Charts'"
    }]
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorAndProgramAreas,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No indicator found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.compareSecSources,
      "allow-empty": false,
      "AllowEmpty": false,
      "show-labels": false,
      "placeholder": _vm.sourcePlaceholder
    },
    on: {
      "open": _vm.openedcompareSecSourcesMultiselect,
      "close": _vm.closedcompareSecSourcesMultiselect
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No source found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.chartData.length) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.highchart_options
    }
  })], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.expandedView,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.expandedView = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-8 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorAndProgramAreas,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No indicator found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.compareSecSources,
      "allow-empty": false,
      "placeholder": _vm.sourcePlaceholder,
      "group-select": false,
      "hide-selected": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedcompareSecSourcesMultiselect,
      "close": _vm.closedcompareSecSourcesMultiselect
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No source found. Change the search query.")])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  })]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [(!_vm.chartData.length) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.highchart_options
    }
  })], 1)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeExpandedBool
    }
  }, [_vm._v("CLOSE")])])])])])], 1)])])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.cb1feab0956813caca73.js